import { render, staticRenderFns } from "./VoDInfoModal.vue?vue&type=template&id=f0e40312"
import script from "./VoDInfoModal.vue?vue&type=script&lang=ts"
export * from "./VoDInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports